import { render, staticRenderFns } from "./PurchaseDocumentsPage.vue?vue&type=template&id=3d287fd4&scoped=true"
import script from "./PurchaseDocumentsPage.vue?vue&type=script&lang=js"
export * from "./PurchaseDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d287fd4",
  null
  
)

export default component.exports